import { Component, ojs, app, EventData, eData } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import { inform, cleanDispose, isMobile } from "../../helpers";
import { STRINGS } from "../../declarations";
import CheckYesno from "../Blocks/CheckYesno";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

export default class CancelOrderForm extends Component {
    holder = null;

    render(...args) {
        return h.empty();
    }

    async showForm(ed, event) {
        let data = EventData.parse(ed);
        const orderId = data.message.get("id", 0);

        if (this.holder) {
            cleanDispose(this.holder);
        }

        if (isMobile()) {
            this.holder = tool.offcanvas(
                [
                    h.CancelOrderCanvas(this.renderForm(orderId)),
                    h.div(
                        {
                            class: "offcanvas-footer p-3",
                            style: "flex-shrink: 0;",
                        },
                        this.renderFooter(orderId),
                    ),
                ],
                { backdrop: true },
            );
        } else {
            this.holder = tool.plainModal(
                h.CancelOrderModal(
                    this.renderForm(orderId),
                    this.renderFooter(orderId),
                ),
                { backdrop: true },
            );
        }
        this.holder.show();
    }

    closeForm() {
        if (this.holder) {
            this.holder.hide();
        }
    }

    renderForm(orderId) {
        return h.div(
            { class: "w-100" },
            // Header
            h.div(
                {
                    class: "d-flex justify-content-between align-items-center mb-4",
                },
                h.h4({ class: "fw-bold text-danger mb-0" }, "Cancel Order"),
                h.button({
                    class: "btn-close bg-light rounded-circle p-2",
                    onclick: this.method("closeForm"),
                    aria_label: "Close",
                }),
            ),

            // Body
            h.div(
                { class: "d-flex flex-column gap-3 mb-4" },
                h.p(
                    { class: "text-muted mb-2 small" },
                    "We're sorry to see you go. Please let us know why you're cancelling this order.",
                ),

                h.div(
                    { class: "d-flex flex-column gap-2" },
                    this.reasonCheckbox("Changed mind"),
                    this.reasonCheckbox("Product no longer needed"),
                    this.reasonCheckbox("Delay in delivery"),
                    this.reasonCheckbox("Deliverer asked me to cancel"),
                    this.reasonCheckbox("Deliverer's misconduct"),

                    // Other
                    h.div(
                        {
                            class: "bg-light rounded-3 p-3 border border-light-subtle mb-3",
                        },
                        h.div(
                            {
                                class: "d-flex justify-content-between align-items-center",
                            },
                            h.span({ class: "fw-semibold text-dark" }, "Other"),
                            h.CheckYesno({
                                name: "cancellation-reason",
                                id: "other-reason",
                                uid: "other-reason",
                                label: { value: "" },
                                onchange: this.method(
                                    "toggleReasonInput",
                                    "${this}",
                                ),
                            }),
                        ),
                        h.textarea({
                            class: "form-control border-light-subtle d-none bg-white mt-2",
                            id: "other-reason-input",
                            rows: "2",
                            placeholder: "Please specify...",
                        }),
                    ),
                ),

                h.div(
                    { class: "mt-2" },
                    h.label(
                        { class: "form-label fw-bold small text-secondary" },
                        "Additional Feedback (Optional)",
                    ),
                    h.textarea({
                        class: "form-control bg-light border-0 p-3 rounded-3",
                        id: "cancel-order-additional-feedback",
                        rows: "3",
                        placeholder:
                            "Share any details that might help us improve...",
                    }),
                ),
            ),
        );
    }

    renderFooter(orderId) {
        return h.div(
            {
                class: "d-flex justify-content-between align-items-center gap-3 w-100",
            },
            h.button(
                {
                    class: "btn btn-light rounded-pill px-4 py-3 fw-bold flex-fill",
                    onclick: this.method("closeForm"),
                },
                "Keep Order",
            ),
            h.button(
                {
                    class: "btn btn-danger rounded-pill px-4 py-3 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2 flex-fill",
                    id: "confirm-cancel-btn",
                    onclick: this.method("submitCancellation", orderId),
                },
                h.span("Confirm"),
                h.i({ class: "fas fa-arrow-right" }),
            ),
        );
    }

    toggleReasonInput(elem) {
        let input = dom.id("other-reason-input");
        elem.checked
            ? input.classList.remove("d-none")
            : input.classList.add("d-none");
        if (elem.checked) input.focus();
    }

    reasonCheckbox(label) {
        let uniqueId = `check-${label
            .replace(/\s+/g, "-")
            .replace(/[^a-zA-Z-]/g, "")
            .toLowerCase()}-${Math.floor(Math.random() * 1000)}`;

        return h.div(
            {
                class: "d-flex justify-content-between align-items-center p-3 border rounded-3 bg-white shadow-sm border-light-subtle mb-2",
            },
            h.span({ class: "fw-semibold text-dark" }, label),
            h.CheckYesno({
                name: "cancellation-reason",
                data_reason: label,
                id: uniqueId,
                uid: uniqueId,
                label: { value: "" },
            }),
        );
    }

    submitCancellation(orderId) {
        let feedback = dom.id("cancel-order-additional-feedback")?.value;
        let reasons = [];
        let reasonsList = dom.all("[name='cancellation-reason']");

        for (let r of reasonsList) {
            if (!r.checked) continue;

            if (r.id == "other-reason") {
                let other = dom.id("other-reason-input");
                if (other?.value.length < 1) {
                    inform("Please state the other reason", STRINGS.WARNING);
                    return;
                }
                reasons.push(other.value);
                continue;
            }

            reasons.push(r.dataset.reason);
        }

        if (reasons.length == 0) {
            return inform("Please select at least one reason", STRINGS.WARNING);
        }

        let btn = dom.id("confirm-cancel-btn");
        dom.put(
            h.div({
                class: "spinner-border spinner-border-sm text-white",
                role: "status",
            }),
            btn,
        );
        dom.disable(btn);

        broker.send(
            $e.order.has.cancellationReason,
            eData(
                {},
                {
                    reasons,
                    feedback,
                    id: orderId,
                },
            ),
        );
    }

    $$order = {
        cancelled: (ed, event) => {
            if (this.holder) this.holder.hide();
        },

        needs: {
            cancellationReason: (ed, event) => this.showForm(ed),
        },

        has: {
            cancellationError: (ed, event) => {
                let btn = dom.id("confirm-cancel-btn");
                if (btn) {
                    dom.enable(btn);
                    dom.put(h.span("Confirm Cancellation"), btn);
                    // dom has no add() - append with put(..., true).
                    dom.put(h.i({ class: "fas fa-arrow-right ps-2" }), btn, true);
                }
            },
        },
    };

    cleanUp() {
        super.cleanUp();
        if (this.holder) cleanDispose(this.holder);
    }
}

export function CancelOrderCanvas(bodyContent) {
    return h.$(
        h.div(
            {
                class: "offcanvas-body p-4",
                style: "flex-grow: 1; overflow-y: auto;",
            },
            bodyContent,
        ),
    );
}

export function CancelOrderModal(bodyContent, footerContent) {
    return h.$(
        h.div(
            {
                class: "modal-content border-0 rounded-4 shadow-lg",
            },
            h.div(
                {
                    class: "modal-body p-4",
                },
                bodyContent,
            ),
            h.div(
                {
                    class: "modal-footer p-4",
                },
                footerContent,
            ),
        ),
    );
}

ojs(CancelOrderForm, CancelOrderCanvas, CancelOrderModal);
